import { useLocation } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Compass } from "lucide-react";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { SIDEBARS, workspaceFromPath, WORKSPACES } from "@/lib/navRegistry";

export default function NotAvailable() {
  const { pathname } = useLocation();
  const wsId = workspaceFromPath(pathname);
  const side = (SIDEBARS[wsId] || []).find((s) => s.route === pathname);
  const ws = WORKSPACES.find((w) => w.id === wsId);
  const title = side?.label || ws?.label || "This area";

  return (
    <div className="animate-fade-up" data-testid="not-available">
      <Breadcrumbs />
      <Card className="flex flex-col items-center justify-center gap-3 px-6 py-24 text-center shadow-soft">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-subtle text-accent">
          <Compass className="h-7 w-7" />
        </span>
        <h2 className="font-heading text-2xl font-semibold text-foreground">{title} — not available yet</h2>
        <p className="max-w-md text-sm text-muted-foreground">
          This part of ContentOS is planned for an upcoming release. The navigation is ready so it can light up the moment the module ships — no fake data in the meantime.
        </p>
      </Card>
    </div>
  );
}
